import React from "react";

import { VaspCardContainer, VASPInfoContainer, StatusContainer, ViewDetailsButton } from "../styles";

import Skeleton from "~/components/Skeleton";

export default function VaspCardSkeleton() {
  return (
    <VaspCardContainer data-testid="vaspCardSkeleton">
      <Skeleton width={80} height={80} circle style={{ marginLeft: 30 }} />
      <VASPInfoContainer>
        <Skeleton count={1} width={200} />
        <StatusContainer>
          <Skeleton count={1} width={100} />
        </StatusContainer>
      </VASPInfoContainer>
      <ViewDetailsButton color="grey-dark">
        <Skeleton width="120px" />
      </ViewDetailsButton>
    </VaspCardContainer>
  );
}
